(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "../_util/vantStyle", "../_util/vantScroll", "../_mixins/vantBindEvent", "../_mixins/vantSlots", "../_style/images/inlineLoadingGif"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("../_util/vantStyle"), require("../_util/vantScroll"), require("../_mixins/vantBindEvent"), require("../_mixins/vantSlots"), require("../_style/images/inlineLoadingGif"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.vantStyle, global.vantScroll, global.vantBindEvent, global.vantSlots, global.inlineLoadingGif);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _vantStyle, _vantScroll, _vantBindEvent, _vantSlots, _inlineLoadingGif) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  // Utils
  // Mixins
  // Components
  var _default2 = {
    name: 'nx-list',
    mixins: [(0, _vantBindEvent.BindEventMixin)(function (bind) {
      if (!this.scroller) {
        this.scroller = (0, _vantScroll.getScroller)(this.$el, window, this.overflowScrollReg);
      }

      bind(this.scroller, 'scroll', this.check);
    }), _vantSlots.SlotsMixin],
    model: {
      prop: 'loading'
    },
    props: {
      error: Boolean,
      loading: Boolean,
      finished: Boolean,
      errorText: String,
      loadingText: {
        type: String,
        default: '正在加载'
      },
      finishedText: String,
      immediateCheck: {
        type: Boolean,
        default: true
      },
      offset: {
        type: [Number, String],
        default: 100
      },
      direction: {
        type: String,
        default: 'down'
      },
      finishedMode: {
        type: String,
        default: '1'
      },
      loadingType: {
        type: String,
        default: 'swivel-image'
      },
      overflowScrollReg: {
        type: RegExp,
        default: function _default() {
          return /scroll|auto/i;
        }
      },
      frozenCheckEdge: {
        type: Boolean,
        default: false
      }
    },
    data: function data() {
      return {
        // use sync innerLoading state to avoid repeated loading in some edge cases
        innerLoading: this.loading,
        calFirstScreenHeight: ''
      };
    },
    updated: function updated() {
      this.innerLoading = this.loading;
      this.calHeight();
    },
    mounted: function mounted() {
      if (this.immediateCheck) {
        this.check();
      }

      this.calHeight();
    },
    watch: {
      loading: 'check',
      finished: 'check',
      scrollerDom: function scrollerDom(dom) {
        if (dom) this.scroller = dom;
      }
    },
    methods: {
      calHeight: function calHeight() {
        if (this.$refs['content']) {
          var viewHeight = window.innerHeight || document.documentElement.clientHeight;

          var _this$$refs$content$g = this.$refs['content'].getBoundingClientRect(),
              bottom = _this$$refs$content$g.bottom,
              top = _this$$refs$content$g.top;

          this.calFirstScreenHeight = bottom - top - viewHeight;
        }
      },
      // @exposed-api
      check: function check() {
        var _this = this;

        if (this.frozenCheckEdge) return;
        this.$nextTick(function () {
          if (_this.innerLoading || _this.finished || _this.error) {
            return;
          }

          var el = _this.$el,
              scroller = _this.scroller,
              offset = _this.offset,
              direction = _this.direction;
          var scrollerRect;

          if (scroller.getBoundingClientRect) {
            scrollerRect = scroller.getBoundingClientRect();
          } else {
            scrollerRect = {
              top: 0,
              bottom: scroller.innerHeight
            };
          }

          var scrollerHeight = scrollerRect.bottom - scrollerRect.top;
          /* istanbul ignore next */

          if (!scrollerHeight || (0, _vantStyle.isHidden)(el)) {
            return false;
          }

          var isReachEdge = false;

          var placeholderRect = _this.$refs.placeholder.getBoundingClientRect();

          if (direction === 'up') {
            isReachEdge = scrollerRect.top - placeholderRect.top <= offset;
          } else {
            isReachEdge = placeholderRect.bottom - scrollerRect.bottom <= offset;
          }

          if (isReachEdge) {
            _this.innerLoading = true;

            _this.$emit('input', true);

            _this.$emit('load');
          }
        });
      },
      clickErrorText: function clickErrorText() {
        this.$emit('update:error', false);
        this.check();
      },
      genLoading: function genLoading() {
        var h = this.$createElement;

        if (this.innerLoading && !this.finished) {
          var loadingSlot = this.slots('loading');
          var _map = {
            'swivel-image': _inlineLoadingGif.inlineLoadingGif,
            'swivel-image-blue': _inlineLoadingGif.inlineLoadingGifBlue
          };
          return loadingSlot || h("div", {
            "key": "loading",
            "class": "nx-list-loading"
          }, [h("img", {
            "class": "nx-inline-loading-gif",
            "attrs": {
              "src": _map[this.loadingType]
            }
          }), h("span", {
            "class": "nx-list-loading-text"
          }, [" ", this.loadingText, " "])]);
        }
      },
      genFinishedText: function genFinishedText() {
        var h = this.$createElement;

        var _v = this.finishedMode === '0' || this.finishedMode === '1' && this.calFirstScreenHeight > 0;

        if (this.finished && !this.innerLoading && _v) {
          var text = this.slots('finished') || this.finishedText;

          if (text) {
            return h("div", {
              "class": "nx-list-finished-text"
            }, [" ", text, " "]);
          }
        }
      },
      genErrorText: function genErrorText() {
        var h = this.$createElement;

        if (this.error) {
          var text = this.slots('error') || this.errorText;

          if (text) {
            return h("div", {
              "on": {
                "click": this.clickErrorText
              },
              "class": "nx-list-error-text"
            }, [text]);
          }
        }
      },
      genSlots: function genSlots(direction) {
        var h = this.$createElement;
        var Placeholder = h("div", {
          "ref": "placeholder",
          "key": "placeholder",
          "class": "nx-list-placeholder"
        });

        if (this.direction !== direction) {
          return Placeholder;
        } else {
          return h("div", {
            "ref": "content"
          }, [this.slots()]);
        }
      }
    },
    render: function render() {
      var h = arguments[0];
      return h("div", {
        "ref": "list",
        "class": "nx-list",
        "attrs": {
          "aria-busy": this.innerLoading
        }
      }, [this.genSlots('down'), this.genLoading(), this.genFinishedText(), this.genErrorText(), this.genSlots('up')]);
    }
  };
  _exports.default = _default2;
});